import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Error } from "../../common/Error";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { pauseSar } from "../../../redux/actions";
import { SarsModel} from "../../../domain/SarsModel";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { sarsPauseEventLookupService } from "../../../services";
import { Select } from "@ofqual/portal-components/components/Select";


export type PauseDialogProps = {
  sar: SarsModel;
  onClose: () => void;
  open: boolean;
};

export const PauseDialog: React.FC<PauseDialogProps> = ({ sar, onClose, open }) => {
  const dispatch = useDispatch();
  const { control, errors, handleSubmit } = useForm({
    defaultValues: { reason: 0, response: "" },
  });

  const onSubmit = (model: { reason: number, response: string }) => {
    dispatch(pauseSar (sar.id, model.reason, model.response));
    onClose();
  };

  const [sarsEventLookups] = useLookup(sarsPauseEventLookupService);

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Pause SAR</DialogTitle>
        <Divider component="div" />
        <DialogContent>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  Please complete the following fields and confirm you wish to
                  pause this subject access request
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="reason"
                  rules={{ required: true }}
                  as={
                    <Select
                      label="Reason"
                      data-test="pause-sar-reason"
                      required
                    >
                      {sarsEventLookups}
                    </Select>
                  }
                />
                {errors.reason && <Error>This field is required</Error>}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="response"
                  rules={{ required: true }}
                  as={
                    <TextField
                      label="Response"
                      data-test="pause-sar-response"
                      required
                      multiline
                      rows={5}
                    />
                  }
                />
                {errors.response && <Error>This field is required</Error>}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            data-test="pause-cancel-button"
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            data-test="pause-confirm-button"
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};


